import { jsx } from "panel";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { ModalEl } from "common/components/modal";
import { SpinnerEl } from "common/components/spinner";
import { TEXT_HIGHLIGHT_THEME, TextHighlightEl } from "common/components/text-highlight";
import { TooltipEl } from "common/components/tooltip";
import { ButtonTheme } from "common/components/button/constants";
import { ShareOptionsLocation, SharingModalViewType } from "common/widgets/sharing/modal/types";
import { truncate } from "common/util/string";
import { BannerEl } from "common/components/banner";
import { BannerAction, BannerTheme, BannerType } from "common/components/banner/types";
import { ButtonEl } from "common/components/button";
import { SwitchEl } from "common/components/switch";
import { TableEl } from "common/components/table";
import { LoadingStatus } from "common/widgets/sharing/types";
import { LinkDetailMixin } from "common/templates/public-dashboards/mixins";
import { Placement } from "common/components/tooltip/types";
import { currentProjectStore } from "common/report/stores/project-details";
import { SvgIconEl } from "common/components/svg-icon";
import TableStyle from "./public-links-table.inline.styl";
import { ShareSection } from "./helpers";
import { UserSearchTagInputEl } from "./user-search-tag-input";
import { PublicBoardBannerEl } from "./public-board-banner";
const PublicDashboardDetailsView = (_ref) => {
  let {
    state,
    helpers,
    showSuperadminBanner
  } = _ref;
  return /* @__PURE__ */ jsx("div", { sel: ".wrapper", class: {
    "no-min-height": helpers.shouldShowUpsellBanner()
  }, "data-sentry-component": "PublicDashboardDetailsView", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("header", { sel: ".modal-header" }, helpers.t("components.sharing.boards.public-board-details")), /* @__PURE__ */ jsx("div", { sel: ".content" }, /* @__PURE__ */ jsx(PublicBoardBannerEl, { showSuperadminBanner, publicDashboardLinks: state.publicDashboardLinks, boardName: helpers.getEntityName(), "data-sentry-element": "PublicBoardBannerEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(TableEl, { sel: ".mp-table", attrs: {
    elref: "publicDashboardLinksTable",
    "empty-message": helpers.t("components.sharing.boards.no-public-urls"),
    "style-override": TableStyle,
    "track-name": "Public Dashboard Links",
    "window-scroll": true,
    "max-body-height": "450px",
    "disable-clickable-rows": true,
    "disable-expandable-rows": true,
    loading: state.publicDashboardLinks.loading === LoadingStatus.Pending
  }, props: {
    rows: helpers.publicDashboard.getPublicDashboardLinksTableRows(),
    columns: helpers.publicDashboard.getPublicDashboardLinksTableCols(),
    rowDetailsRenderer: LinkDetailMixin(helpers.publicDashboard.handlePasswordChange)
  }, on: {
    rowDetailsVisibilityChange: helpers.publicDashboard.handleRowDetailsVisibilityChange
  }, "data-sentry-element": "TableEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("footer", { sel: ".modal-actions" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".public-dashboard-back-button", attrs: {
    elref: "publicDashboardDetailsBackButton",
    theme: ButtonTheme.Secondary
  }, on: {
    click: () => helpers.publicDashboard.updateSharingModalViewType(SharingModalViewType.Sharing)
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, helpers.t("common.back")), /* @__PURE__ */ jsx(ButtonEl, { sel: ".public-dashboard-done-button", attrs: {
    theme: ButtonTheme.Primary
  }, on: {
    click: helpers.publicDashboard.handlePublicDashboardDoneClick
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, helpers.t("common.done"))));
};
export function template() {
  const {
    pendingCanEdit,
    pendingGrants,
    searchText,
    showCopyLinkText,
    showPopover,
    publicDashboardEnabled,
    modalViewType
  } = this.state;
  const projectMemberCount = this.helpers.getProjectMemberCount();
  const showDisabledBanner = this.attr("disabled") && this.attr("disabled-reason") && !this.helpers.shouldShowUpsellBanner();
  const showSuperadminBanner = this.attr("is-superadmin") && !this.helpers.shouldShowUpsellBanner();
  const showSuccessBanner = this.attr("success-message") && !this.helpers.shouldShowUpsellBanner();
  const orgId = currentProjectStore.value.organizationId;
  return /* @__PURE__ */ jsx(ModalEl, { sel: ".mp-modal", attrs: {
    closeable: true,
    "modal-title": "Share this ".concat(this.helpers.getEntityTypeTitle(), " With Others"),
    "modal-description": "Modal for managing sharing permissions",
    open: this.attr("open"),
    "hide-close-button": showSuccessBanner
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, modalViewType === SharingModalViewType.PublicDashboardDetails ? /* @__PURE__ */ jsx(PublicDashboardDetailsView, { state: this.state, helpers: this.helpers, showSuperadminBanner }) : /* @__PURE__ */ jsx("div", { sel: ".wrapper", class: {
    "no-min-height": this.helpers.shouldShowUpsellBanner(),
    "with-banner": showDisabledBanner || showSuperadminBanner
  } }, showSuccessBanner ? /* @__PURE__ */ jsx("div", { sel: ".success-content" }, /* @__PURE__ */ jsx(BannerEl, { attrs: {
    "body-text": this.attr("success-message"),
    theme: BannerTheme.Success,
    type: BannerType.Embedded
  } })) : null, /* @__PURE__ */ jsx("header", { sel: ".modal-header" }, this.t("components.sharing.title", {
    context: this.attr("type")
  })), /* @__PURE__ */ jsx("div", { sel: ".content" }, showDisabledBanner ? /* @__PURE__ */ jsx(BannerEl, { style: {
    "margin-bottom": "20px"
  }, attrs: {
    "body-text": this.attr("disabled-reason"),
    theme: BannerTheme.Info,
    type: BannerType.Embedded
  } }) : null, showSuperadminBanner ? /* @__PURE__ */ jsx(BannerEl, { style: {
    "margin-bottom": "20px"
  }, attrs: {
    "body-text": this.t("components.sharing.superadmin-access", {
      context: this.attr("type")
    }),
    theme: BannerTheme.Info,
    type: BannerType.Embedded
  } }) : null, this.helpers.showExistingSharesSection() ? /* @__PURE__ */ jsx(null, null, this.helpers.shouldShowUpsellBanner() ? /* @__PURE__ */ jsx(null, null, this.state.upsellInfo ? /* @__PURE__ */ jsx(BannerEl, { attrs: {
    elref: "upsellBanner",
    theme: BannerTheme.Info,
    type: BannerType.Embedded,
    "header-text": this.state.upsellInfo.title,
    "body-text": this.state.upsellInfo.description,
    ctas: [{
      text: "Upgrade Plan",
      actionName: BannerAction.Upgrade,
      theme: ButtonTheme.Tertiary,
      href: "/pricing/plan-builder/?org=".concat(orgId)
    }]
  } }) : /* @__PURE__ */ jsx(BannerEl, { attrs: {
    elref: "upsellBanner",
    theme: BannerTheme.Info,
    type: BannerType.Embedded,
    "body-text": this.t("components.sharing.upsell-description", {
      planName: currentProjectStore.value.eventsPlanName
    }),
    ctas: [{
      text: this.t("common.upgrade"),
      actionName: BannerAction.Upgrade,
      icon: "share",
      theme: ButtonTheme.Tertiary,
      href: "/pricing"
    }]
  } }), /* @__PURE__ */ jsx("div", { sel: ".existing-shares", attrs: {
    elref: "existingShares"
  }, key: "existing-shares", class: {
    "viewer-state": this.attr("disabled")
  } }, ShareSection("People", null, this.helpers, true))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(UserSearchTagInputEl, { params: {
    tags: this.helpers.picker.getTags(),
    selectOptions: this.helpers.getSelectOptions(ShareOptionsLocation.PickerControls),
    disabled: this.attr("disabled"),
    placeholder: this.t("components.sharing.invite-placeholder"),
    menuSections: this.helpers.picker.getMenuSections(),
    selectedInputOption: pendingCanEdit ? this.t("mixology.user-access.editor") : this.t("mixology.user-access.viewer"),
    picker: this.helpers.picker,
    cta: {
      text: this.t("common.share"),
      disabled: pendingGrants.size === 0,
      onClick: this.helpers.picker.handleShareButtonClick
    },
    searchText,
    showPopover
  } }), /* @__PURE__ */ jsx("div", { sel: ".existing-shares", attrs: {
    elref: "existingShares"
  }, key: "existing-shares", class: {
    "viewer-state": this.attr("disabled")
  } }, ShareSection("People", this.helpers.existingShares.getUserGrants(), this.helpers, this.attr("disabled")), ShareSection("Teams", this.helpers.existingShares.getTeamGrants(), this.helpers, this.attr("disabled"))))) : /* @__PURE__ */ jsx("div", { sel: ".placeholder" }, /* @__PURE__ */ jsx("span", null, this.t("components.sharing.loading")), /* @__PURE__ */ jsx(SpinnerEl, { sel: ".mp-spinner" }))), this.helpers.showProjectShareSection() ? /* @__PURE__ */ jsx("div", { sel: ".share-section--project", attrs: {
    elref: "shareSectionProject"
  } }, /* @__PURE__ */ jsx("header", { sel: ".header" }, this.helpers.publicDashboard.showPublicDashboardSwitch() ? this.t("components.sharing.advanced") : this.t("components.sharing.project")), /* @__PURE__ */ jsx("ul", { sel: ".share-list" }, /* @__PURE__ */ jsx("li", { sel: ".project-share.share-list-item" }, /* @__PURE__ */ jsx("div", { sel: ".display" }, /* @__PURE__ */ jsx("div", { sel: ".name-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".project-name" }, this.helpers.getProjectShareLabel()), !this.helpers.shouldShowUpsellBanner() && /* @__PURE__ */ jsx(TextHighlightEl, { sel: ".mp-text-highlight", attrs: {
    theme: TEXT_HIGHLIGHT_THEME.SUCCESS,
    text: this.helpers.getProjectShareGrantStatus()
  } })), this.attr("disabled") || this.helpers.publicDashboard.showPublicDashboardSwitch() ? null : /* @__PURE__ */ jsx("div", { sel: ".subtitle" }, this.t("components.sharing.members", {
    count: projectMemberCount
  }))), /* @__PURE__ */ jsx("div", { sel: ".controls" }, /* @__PURE__ */ jsx(SelectEl, { sel: ".share-level", attrs: {
    "disable-search": true,
    "menu-width": 120,
    theme: SelectTheme.Tertiary,
    "always-show-caret": true,
    "selected-option": this.helpers.getProjectShareSelectOption(),
    elref: "selectShareLevel_".concat(this.attr("project-id")),
    disabled: this.attr("disabled")
  }, params: {
    sections: this.helpers.getSelectOptions(ShareOptionsLocation.ProjectShare)
  }, on: {
    change: this.helpers.handleProjectShareSelectChange
  } }))), this.helpers.publicDashboard.showPublicDashboardSwitch() ? /* @__PURE__ */ jsx("li", { sel: ".project-share.share-list-item" }, /* @__PURE__ */ jsx("div", { sel: ".display" }, /* @__PURE__ */ jsx("div", { sel: ".name-wrapper", class: {
    disabled: !this.helpers.publicDashboard.projectHasFeatureEnabled()
  } }, /* @__PURE__ */ jsx("div", { sel: ".project-name" }, this.t("components.sharing.boards.make-public"), "\xA0"), this.helpers.hasWorkspacesFeatureGate() ? /* @__PURE__ */ jsx("div", { sel: ".workspace-name" }, "via ".concat(truncate(this.helpers.getCurrentWorkspaceName(), 60))) : null, !this.helpers.publicDashboard.projectHasFeatureEnabled() && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info",
    elref: "disabledInfoIcon"
  } }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: this.t("components.sharing.boards.share-publicly", {
      link: "/settings/project/".concat(currentProjectStore.value.id, "/public-dashboards")
    }),
    placement: Placement.Right,
    elref: "disabledTextTooltip",
    "delay-out": 1e3
  } })))), /* @__PURE__ */ jsx("div", { sel: ".controls" }, !this.helpers.publicDashboard.canToggleFreePublicDashboards() && !this.helpers.projectHasIntegrated() && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: this.t("components.sharing.boards.empty-project"),
    placement: Placement.Top,
    elref: "disabledToggleTooltip"
  } }), /* @__PURE__ */ jsx(SwitchEl, { sel: ".public-dashboard-switch", attrs: {
    on: publicDashboardEnabled,
    disabled: this.helpers.isSharingEnabledForProject() && this.attr("disabled") || !this.helpers.isSharingEnabledForProject() && !this.helpers.publicDashboard.canToggleFreePublicDashboards() || !this.helpers.publicDashboard.projectHasFeatureEnabled(),
    elref: "publicDashboardSwitch"
  }, on: {
    change: this.helpers.publicDashboard.handlePublicDashboardSwitchChange
  } }))) : null)) : null, /* @__PURE__ */ jsx("footer", { sel: ".modal-actions" }, /* @__PURE__ */ jsx("div", { sel: ".copy-link-button-wrapper" }, /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: this.t("components.sharing.url-tooltip")
  } }), /* @__PURE__ */ jsx(ButtonEl, { sel: ".copy-link-button", attrs: {
    theme: ButtonTheme.Tertiary,
    icon: this.helpers.shouldShowCopyLinkSpinner() ? "spinner" : "link",
    disabled: this.helpers.shouldShowCopyLinkSpinner()
  }, on: {
    click: this.helpers.shortUrl.handleCopyLinkClick
  } }, this.t("common.copy-url")), showCopyLinkText ? /* @__PURE__ */ jsx("input", { sel: ".copy-link-input", attrs: {
    type: "text",
    readonly: true
  }, hook: {
    insert: (_ref2) => {
      let {
        elm
      } = _ref2;
      return this.helpers.handleCopyLinkInputInsert(elm);
    }
  }, on: {
    click: this.helpers.handleCopyLinkInputClick
  } }) : null), !showCopyLinkText && !this.helpers.publicDashboard.showPublicDashboardSwitch() && !this.helpers.shouldShowUpsellBanner() ? /* @__PURE__ */ jsx("span", { sel: ".link-info" }, this.t("components.sharing.url-description")) : null, this.helpers.publicDashboard.showPublicDashboardSwitch() && this.helpers.publicDashboard.projectHasFeatureEnabled() && this.helpers.publicDashboard.canToggleFreePublicDashboards() ? /* @__PURE__ */ jsx(ButtonEl, { sel: ".public-dashboard-detail-button", attrs: {
    elref: "publicDashboardDetailsButton",
    theme: ButtonTheme.Tertiary,
    icon: "settings"
  }, on: {
    click: () => this.helpers.publicDashboard.updateSharingModalViewType(SharingModalViewType.PublicDashboardDetails)
  } }, this.t("components.sharing.boards.public-board-details")) : null, this.helpers.showExistingSharesSection() && !this.helpers.publicDashboard.showPublicDashboardSwitch() && !this.helpers.shouldShowUpsellBanner() ? /* @__PURE__ */ jsx(ButtonEl, { sel: ".share-done-button", attrs: {
    theme: ButtonTheme.Primary
  }, on: {
    click: () => this.helpers.handleDoneButtonClick()
  } }, this.helpers.t("common.done")) : null)));
}
